module.exports = __webpack_public_path__ + "img/logo3.cebc644a.png";